var country = LhApp.Context.Country;

function resizeFrame(el, iFrResValue) {
    $(el).iFrameResize({
        heightCalculationMethod: (iFrResValue) ? iFrResValue : 'lowestElement', interval: 1000,
        onInit: function () {
            $(el).addClass('iframe-resize-initialized');
        },
        onResized: function () {
            if (country != 'GB') { 
                $(el).attr('data-iframe-resize-times', parseInt($(el).attr('data-iframe-resize-times') || 0) + 1);
                if ($(el).is('.iframe-resize-initialized') && parseInt($(el).attr('data-iframe-resize-times')) > 10) $(el).css("max-height", $(el).outerHeight(true));
            }
        }
    }); 
    // Alternative value: taggedElement
}

function preventFirefoxScroll(el) {
    var userAgent = navigator.userAgent;
    if (userAgent.match(/firefox|fxios/i)) {
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        var scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
        var disablenext = function (e) {
            window.scrollTo(scrollLeft, scrollTop);
            document.removeEventListener('scroll', disablenext);
            return false;
        }
        document.addEventListener('scroll', disablenext);
    }
    resizeFrame(el); 
}
